import { Injectable } from "@angular/core";
import { PrizeApi } from "@lbsdk/*";
import { forkJoin } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PrizeService {
  constructor(private prizeApi: PrizeApi) {}

  getPrizes(filter) {
    return this.prizeApi.find(filter);
  }

  deleteById(prizeId: string) {
    return this.prizeApi.deleteById(prizeId);
  }

  savePrizes(prizes, gameId: string) {
    const observables = [];
    if (!gameId) {
      for (const prize of prizes) {
        observables.push(this.prizeApi.create(prize));
      }

      forkJoin(observables).subscribe(
        (res) => {},
        (error) => {}
      );
    } else {
      for (const prize of prizes) {
        if (!prize.id) {
          observables.push(this.prizeApi.create(prize));
        } else if (prize.id && prize.type === "auto select") {
          observables.push(this.prizeApi.patchAttributes(prize.id, prize));
        } else if (prize.id && prize.type === "solo") {
          observables.push(this.prizeApi.patchAttributes(prize.id, prize));
        } else if (prize.id && prize.type === "top 6") {
          observables.push(this.prizeApi.patchAttributes(prize.id, prize));
        } else if (
          prize.id &&
          prize.type === "exact match" &&
          prize.cashPrizeValue
        ) {
          observables.push(this.prizeApi.patchAttributes(prize.id, prize));
        } else if (
          prize.id &&
          !prize.cashPrizeValue &&
          prize.type === "exact match"
        ) {
          observables.push(this.prizeApi.deleteById(prize.id));
        } else if (prize.id && prize.type === "deletePrize") {
          observables.push(this.prizeApi.deleteById(prize.id));
        }
      }

      forkJoin(observables).subscribe(
        (res) => {},
        (error) => {}
      );
    }
  }
}
